import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent implements OnInit {
  isBadgesSageCom = false;

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  ngOnInit(): void {
    this.isBadgesSageCom = this._document.location.hostname === 'badges.sage.com';
  }
}
